var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.322,
    height: 48.039,
    viewBox: "0 0 45.322 48.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_574",
    "data-name": "Groupe 574",
    transform: "translate(-303.052 -263.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_4",
    "data-name": "Soustraction 4",
    d: "M336.813,311.7h-25.1a6.007,6.007,0,0,1-6-6V280.6l4,4v21.1a2,2,0,0,0,2,2h21.1Zm8.9-15.015h0l-4-4V280.991c-1.5-2.1-8.507-10.915-10.492-13.338-.451,0-1.079.008-1.806.016h-.122c-2.017.021-5.065.053-9.814.053H316.75l-4.017-4.017c2.3.013,4.6.02,6.831.02,4.859,0,8.047-.035,9.76-.054.67-.007,1.247-.013,1.709-.013,1.88,0,2.039.1,2.567.625.393.392,4.872,6.027,6.05,7.514,6.063,7.662,6.063,7.753,6.063,8.623v16.262Z",
    fill: "#9a96a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1433",
    "data-name": "Rectangle 1433",
    d: "M306.387,265.588,347.8,307a1.953,1.953,0,0,1,0,2.763h0a1.955,1.955,0,0,1-2.763,0l-41.415-41.414a1.954,1.954,0,0,1,0-2.763h0A1.954,1.954,0,0,1,306.387,265.588Z",
    fill: "#9a96a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.34491e7249f63ea209021aa6a715b27d.svg";
export { ForwardRef as ReactComponent };